(function ($) {

    $('.search-form__submit').on('click', function () {

        // Search submission handled natively by the form

    });

}(jQuery));
